<div class="session-select">
  <m-dropdown
    v-if="hasAvailableSessions"
    v-model="selectedSession"
    :label="$i18next.t('modules.global.session.SessionSelect.label')"
  >
    <template v-for="session in availableSessions">
      <m-dropdown-item
        :value="session"
        :label="session.abreviation"
      />
    </template>
  </m-dropdown>
  <m-tooltip placement="right">
    {{ $i18next.t('modules.global.session.SessionSelect.tooltip') }}
  </m-tooltip>
</div>